import { MetricModel } from 'src/app/shared/models/metric.model'
import {
  obstacleLegendProvider1Data,
  obstacleLegendProvider2Data,
  obstacleLegendProvider3Data,
  obstacleLegendProvider4Data,
  obstacleLegendProvider6Data,
  obstacleLegendProvider7Data,
  obstacleLegendProvider8Data,
  obstacleLegendProvider9Data,
  roadHazardLegendObstacles,
} from '../utils/obstacle-legend-utils'
import { defaultExpression, defaultLegend } from 'src/app/shared/utils/metric.utils'
import { createPaintExpression } from '../utils/obstacle-paint-utils'

export enum ObstaclesMetrics {
  Obstacles_Accidents = 'ob_a',
  Obstacles_BDV = 'ob_bdv',
  Obstacles_Provider1 = 'ob_p1',
  Obstacles_Provider2 = 'ob_p2',
  Obstacles_Provider3 = 'ob_p3',
  Obstacles_Provider4 = 'ob_p4',
  Obstacles_Provider6 = 'ob_p6',
  Obstacles_Provider7 = 'ob_p7',
  Obstacles_Provider8 = 'ob_p8',
  Obstacles_Provider9 = 'ob_p9',
}

export const getMetricFromMap = (metric: string): MetricModel => {
  return (
    ObstacleMetricMap.get(metric) || {
      displayName: 'Default',
      expression: defaultExpression,
      name: 'default',
      icon: 'question',
      key: 'default',
      legend: defaultLegend,
    }
  )
}

export const ObstacleMetricMap = new Map<string, MetricModel>()

ObstacleMetricMap.set(ObstaclesMetrics.Obstacles_Accidents, {
  name: 'accident',
  expression: createPaintExpression('accident'),
  icon: 'car-crash',
  key: ObstaclesMetrics.Obstacles_Accidents,
  displayName: '',
  legend: roadHazardLegendObstacles,
})

ObstacleMetricMap.set(ObstaclesMetrics.Obstacles_BDV, {
  name: 'brokenDownVehicle',
  expression: createPaintExpression('brokenDownVehicle'),
  icon: 'car-mechanic',
  key: ObstaclesMetrics.Obstacles_BDV,
  displayName: '',
  legend: roadHazardLegendObstacles,
})

ObstacleMetricMap.set(ObstaclesMetrics.Obstacles_Provider1, {
  name: 'provider1Obstacles',
  expression: ['==', ['get', 'obstacles'], ObstaclesMetrics.Obstacles_Provider1],
  icon: 'car-crash',
  key: ObstaclesMetrics.Obstacles_Provider1,
  displayName: 'Provider1 Obstacles',
  legend: obstacleLegendProvider1Data,
})

ObstacleMetricMap.set(ObstaclesMetrics.Obstacles_Provider2, {
  name: 'provider2Obstacles',
  expression: ['==', ['get', 'obstacles'], ObstaclesMetrics.Obstacles_Provider2],
  icon: 'car-crash',
  key: ObstaclesMetrics.Obstacles_Provider2,
  displayName: 'Provider2 Obstacles',
  legend: obstacleLegendProvider2Data,
})

ObstacleMetricMap.set(ObstaclesMetrics.Obstacles_Provider3, {
  name: 'provider3Obstacles',
  expression: ['==', ['get', 'obstacles'], ObstaclesMetrics.Obstacles_Provider3],
  icon: 'car-crash',
  key: ObstaclesMetrics.Obstacles_Provider3,
  displayName: 'Provider3 Obstacles',
  legend: obstacleLegendProvider3Data,
})

ObstacleMetricMap.set(ObstaclesMetrics.Obstacles_Provider4, {
  name: 'obstacles',
  expression: ['==', ['get', 'obstacles'], ObstaclesMetrics.Obstacles_Provider4],
  icon: 'car-crash',
  key: ObstaclesMetrics.Obstacles_Provider4,
  displayName: 'obstacles',
  legend: obstacleLegendProvider4Data,
})

ObstacleMetricMap.set(ObstaclesMetrics.Obstacles_Provider6, {
  name: 'provider6Obstacles',
  expression: ['==', ['get', 'obstacles'], ObstaclesMetrics.Obstacles_Provider6],
  icon: 'car-crash',
  key: ObstaclesMetrics.Obstacles_Provider6,
  displayName: 'GIS Obstacles',
  legend: obstacleLegendProvider6Data,
})

ObstacleMetricMap.set(ObstaclesMetrics.Obstacles_Provider7, {
  name: 'provider7Obstacles',
  expression: ['==', ['get', 'obstacles'], ObstaclesMetrics.Obstacles_Provider7],
  icon: 'car-crash',
  key: ObstaclesMetrics.Obstacles_Provider7,
  displayName: 'Traffic England Obstacles',
  legend: obstacleLegendProvider7Data,
})

ObstacleMetricMap.set(ObstaclesMetrics.Obstacles_Provider8, {
  name: 'provider8Obstacles',
  expression: ['==', ['get', 'obstacles'], ObstaclesMetrics.Obstacles_Provider8],
  icon: 'car-crash',
  key: ObstaclesMetrics.Obstacles_Provider8,
  displayName: 'Provider8 Obstacles',
  legend: obstacleLegendProvider8Data,
})

ObstacleMetricMap.set(ObstaclesMetrics.Obstacles_Provider9, {
  name: 'provider9Obstacles',
  expression: ['==', ['get', 'obstacles'], ObstaclesMetrics.Obstacles_Provider9],
  icon: 'car-crash',
  key: ObstaclesMetrics.Obstacles_Provider9,
  displayName: 'Provider9 Obstacles',
  legend: obstacleLegendProvider9Data,
})
